var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 2V8H1.5V2H7.5ZM4.02538 3.5H3.44104L2.33166 6.5H2.85883L3.06827 5.91352H4.39629L4.60124 6.5H5.16017L4.02538 3.5ZM6.09595 3.5H5.57089V6.5H6.09595V3.5ZM3.72878 4.00333L4.25177 5.49999H3.2141L3.72878 4.00333ZM8 6.5H9V7.5H8V6.5ZM2 8.5H3V9.5H2V8.5ZM4 8.5H5V9.5H4V8.5ZM2 0.5H3V1.5H2V0.5ZM6 8.5H7V9.5H6V8.5ZM4 0.5H5V1.5H4V0.5ZM6 0.5H7V1.5H6V0.5ZM8 4.5H9V5.5H8V4.5ZM0 6.5H1V7.5H0V6.5ZM8 2.5H9V3.5H8V2.5ZM0 4.5H1V5.5H0V4.5ZM0 2.5H1V3.5H0V2.5Z",
    fill: "#1AA260"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/AiIcon.9bb17ee608a488dfc765115987fe2f53.svg";
export { ForwardRef as ReactComponent };